import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Box, TextField, FormLabel, MenuItem, Select, Typography, OutlinedInput, FormControl, Switch, FormControlLabel } from '@mui/material';
import { Button} from '@mui/joy';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/system';

const CustomSwitch = styled(Switch)(() => ({
    width: '60px', // Adjust width for spare shape
    height: '40px',
    padding: 10,
    '& .MuiSwitch-switchBase': {
        padding: 12,
        '&.Mui-checked': {
            transform: 'translateX(22px)',
            '& + .MuiSwitch-track': {
                backgroundColor:`rgba(0, 0, 0, 0.2)`, 
                opacity: 1,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: '15px',
        height: '15px',
        borderRadius: '2px', // Make the thumb circular
        backgroundColor: '#fff',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
    },
    '& .MuiSwitch-track': {
        borderRadius: '5px',
        backgroundColor:`rgba(0, 0, 0, 0.3)`,
        opacity: 1,
    },
}));

const validationSchema = yup.object({
    fName: yup.string().required(),
    lName: yup.string().required(),
    tagline: yup.string().required(),
    address: yup.string().required(),
    city: yup.string().required(),
    zip: yup.string().required(),
});


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight: personName.includes(name)
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular,
    };
}

const FundiAccountSetting = () => {
    const theme = useTheme();
    const [personName, setPersonName] = useState([]);
    const formik = useFormik({
        initialValues: {
            fName: '',
            lName: '',
            tagline: '',
            address: '',
            city: '',
            zip: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Box sx={{ display: 'flex', justifyItems: 'center', justifyContent: 'space-between', height:'40px',textAlign:'center', border:'0.5px solid #666666',borderRadius:'5px'}}>
                  <Typography variant="body1" color="#666666" m={'auto 0'} pl={2}>Make your profile photo visible to all craftman</Typography>
                  
                    
                        <FormControlLabel
                            control={<CustomSwitch />}
                        />
                   
                </Box>

                <Box sx={{ mb: 2 }}>
                    <Typography variant="h6" color="#666666">Deactiveted Account</Typography>
                    <FormLabel>Your Tagline</FormLabel>
                    <FormControl sx={{ m: 1, width: "100%", mt: 3, outline: "none" }}>
                        <Select
                            multiple
                            displayEmpty
                            value={personName}
                            onChange={handleChange}

                            sx={{

                                "& .MuiSelect-icon": {
                                    color: "#28A745",
                                },
                            }}


                            input={<OutlinedInput />}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <span>Why you want to leave</span>;
                                }

                                return selected.join(', ');
                            }}
                            MenuProps={MenuProps}
                            inputProps={{ 'aria-label': 'Without label' }}
                        >

                            {names.map((name) => (
                                <MenuItem
                                    key={name}
                                    value={name}
                                    style={getStyles(name, personName, theme)}
                                >
                                    {name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ mb: 2 }}>

                    <FormLabel sx={{ mb: 2, color: "#666666", fontSize: '18px' }}>Description </FormLabel>
                    <TextField

                        multiline
                        rows={5}

                        onChange={handleChange}
                        variant="outlined"
                        sx={{
                            width: "100%",
                        }}
                    />
                </Box>


                <Box sx={{ display: 'flex', justifyItems: 'flex-end', justifyContent: 'end' }}>
                    <Button
                        sx={{
                            backgroundColor: "#28A745",
                            width: "200px",
                            height: "36px",
                            marginBottom: '20px',
                            color: "#fff",
                            border: "0.5px solid #28A745",
                            fontSize: "16px",
                            fontWeight: 500,
                            borderRadius: "6px",
                            lineHeight: "19.5px",
                            "&:hover": {
                                backgroundColor: "#28A745",
                                color: "#fff", boxShadow: 3,
                            }
                        }}
                    >
                        Save & Update
                    </Button>
                </Box>

            </form>
        </Box>
    );
};

export default FundiAccountSetting;
